<template>
	<div class="c-bucket-sidebar">
		<div class="c-list">
			<div :class="['c-list__item']">
				<div class="c-list__content">
					<span class="muted">Buckets</span>
				</div>
				<div class="c-tooltip" @click="showTutorial">
					<span> ? </span>
				</div>
			</div>
			<!-- <div class="c-bucket-sidebar__info">
				<p>Highlight with different colors via buckets.</p>
			</div> -->
			<div class="c-bucket-sidebar__inner">
				<div
					v-b-tooltip.hover
					:title="bucket.title"
					v-for="bucket in buckets"
					:key="bucket._id"
					:class="[
						'color',
						'c' + bucket.color,
						{ active: currentBucket && bucket._id === currentBucket._id },
					]"
					@click.prevent="onEditBucket(bucket)"
				>
					<!-- <div :class="['c-list__icon', 'color', 'c' + bucket.color]"></div>
				<div class="c-list__content">
					<span>{{ bucket.title }}</span>
				</div>
				<b-dropdown class="c-list__btn" variant="link">
					<template v-slot:button-content>
						<more-horizontal-icon size="1x"></more-horizontal-icon>
					</template>
					<b-dropdown-item href="#" @click.prevent="onEditBucket(bucket)"
						>Edit</b-dropdown-item
					>
					<b-dropdown-item
						href="#"
						@click.prevent="onDeleteBucket(bucket)"
						class="danger"
						>Delete</b-dropdown-item
					>
				</b-dropdown> -->
				</div>
				<div
					v-if="buckets.length < 6"
					class="color color__add"
					@click="onAddBucket"
				>
					<plus-icon size="1x"></plus-icon>
				</div>
				<div class="" v-else>
					<span class="muted"> </span>
				</div>
			</div>
		</div>
		<modalAddbucket> </modalAddbucket>
		<modalEditbucket ref="editBucketModal"> </modalEditbucket>
		<bucketTutorial ref="tutorial"></bucketTutorial>
	</div>
</template>

<script>
import modalAddbucket from '@/components/modals/modal-addbucket.vue';
import modalEditbucket from '@/components/modals/modal-editbucket.vue';

import bucketTutorial from '@/components/tutorials/bucket-tutorial.vue';
import { PlusIcon, MoreHorizontalIcon } from 'vue-feather-icons';
export default {
	components: {
		PlusIcon,
		MoreHorizontalIcon,
		modalAddbucket,
		modalEditbucket,
		bucketTutorial,
	},
	data: function () {
		var obj = {
			currentBucket: null,
			tutorial: {
				slide: 0,
				sliding: null,
			},
		};
		return obj;
	},
	computed: {
		buckets: function () {
			return this.$store.getters['bucket/buckets'];
		},
		notes: function () {
			return this.$store.getters['note/notes'];
		},
	},
	methods: {
		showTutorial: function () {
			this.$refs.tutorial.show();
		},
		onDeleteBucket: function (bucket) {
			this.currentBucket = null;
			this.$store.dispatch('bucket/removeBucket', bucket._id);
			this.$emit('onBucketChange', null);
		},
		onEditBucket: function (bucket) {
			this.$refs.editBucketModal.setBucket(bucket);
			this.$bvModal.show('modal-editbucket');
		},
		onAddBucket: function () {
			this.$bvModal.show('modal-addbucket');
		},
		onClear: function () {
			this.currentBucket = null;
			this.$emit('onBucketChange', null);
		},
		// onClick: function (bucket) {
		// 	this.currentBucket = bucket;
		// 	this.$emit('onBucketChange', bucket);
		// },
	},
};
</script>

<style lang="scss">
.c-bucket-sidebar {
	&__info {
		padding: var(--margin-lg);
		font-size: var(--font-size-sm);
		background-color: rgba(0, 0, 0, 0.4);
	}

	.color {
		width: calc(var(--spacer) / 1.5);
		height: calc(var(--spacer) / 1.5);
		margin-right: var(--margin-lg);
		border-radius: 50%;
		cursor: pointer;

		&__add {
			border: none;
			padding: 0;
			display: inline-flex;
			justify-content: center;
			align-items: center;
		}
	}

	&__inner {
		padding: 0 var(--margin-lg);
		display: flex;
	}

	.c-list {
		&__icon {
			opacity: 1;
		}
	}
}
</style>
